import { TLocale } from "./TLocale";

type SUCCESS_MESSAGES_KEYS = 
| 'signedUp'
| 'activated-user'
;

const SUCCESS_MESSAGES_ENG: Record<SUCCESS_MESSAGES_KEYS, string> = {
  'signedUp':  'Successful registration!',
  'activated-user': 'Successful activation!'
};

export function getMsg(key: SUCCESS_MESSAGES_KEYS, locale?: TLocale): string {
  return {
    'eng': SUCCESS_MESSAGES_ENG
  }[locale ?? 'eng'][key];
}
